/**
 * Computes the combined style object for a child widget, based on widget configuration and additional styles.
 *
 * @param {WidgetProps<any, any>} props - The widget props containing config with optional style information.
 * @param {React.CSSProperties} [additionalStyle] - Optional additional styles to be merged with the config style.
 * @returns {React.CSSProperties | undefined} The resulting combined style object, or `undefined` if no styles apply.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getChildWidgetStyle(props, additionalStyle) {
    const style = props.config.style;
    if (style) {
        if (style.width != null ||
            style.paddingLeft != null ||
            style.paddingRight != null ||
            style.paddingTop != null ||
            style.paddingBottom != null) {
            return Object.assign(Object.assign({}, additionalStyle), { width: style.width, paddingLeft: style.paddingLeft, paddingRight: style.paddingRight, paddingTop: style.paddingTop, paddingBottom: style.paddingBottom });
        }
    }
    return additionalStyle;
}
